import { Component } from '@angular/core';

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.scss'],
})
export class PartnersComponent {
  logoSlideConfig = {
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    autoplay: true,
    autoplaySpeed: 2500,
    arrows: false,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  slideConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
  };

  partnerLogos = [
    {
      img: '/assets/img/partners/sales_trend.png',
      name: 'Sales Trend',
      link: 'https://salestrend.top/?ref=1556',
      desc: 'partner_sales_trend_des',
    },
    {
      img: '/assets/img/partners/ringostat.png',
      name: 'Ringostat',
      link: 'https://ringostat.com/',
      desc: 'partner_ringostat_des',
    },
    {
      img: '/assets/img/partners/neuron24.jpg',
      name: 'Neuron24',
      link: 'https://neuron-systems.com/',
      desc: 'partner_neuron24_des',
    },
  ];

  images = [
    {
      img: '/assets/img/clients/bossauto.jpg',
      heading: 'BOSS AUTO UKRAINE',
      description: 'partners_bossauto',
      link: 'https://bossautoukraine.com.ua/',
    },
    {
      img: '/assets/img/clients/the_parkan.jpeg',
      heading: 'THE_PARKAN',
      description: 'partner_the_parkan',
      link: 'https://www.instagram.com/the_parkan/',
    },
    {
      img: '/assets/img/clients/mixcenter.webp',
      heading: 'MIXCENTRE',
      description: 'partner_mixcenter',
      link: 'https://mixcenter.olx.ua/uk/home/?utm_source=jecrm.org',
    },
  ];
}
